export const APP_DOWNLOAD_BANNER_STYLES = {
  root: "relative w-full",
  card: "relative flex flex-col items-center gap-4 overflow-hidden rounded-[24px] bg-gradient-to-r from-ticketon-dark-blue to-ticketon-blue px-6 py-5 md:h-[140px] md:flex-row md:items-center md:justify-between md:gap-8 md:px-[60px] md:py-0 md:pr-[320px]",
  description:
    "flex-1 text-center text-[14px] text-white md:max-w-[440px] md:text-left md:text-[18px] md:leading-[1.3]",
  badges: "flex shrink-0 flex-wrap items-center justify-center gap-3",
  badge: "h-[42px] w-auto md:h-[44px]",
  phoneWrapper: "",
  phoneImage:
    "pointer-events-none absolute -top-[45px] right-0 hidden h-[230px] w-auto max-w-none translate-x-[70px] md:block lg:-top-[60px] lg:h-[270px] lg:translate-x-[90px]",
} as const;
